<template>
	<v-dialog v-model="dialog" max-width="500px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="#1A237E" class="text-lowercase" icon v-on="on">
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-icon small v-on="on">mdi-lead-pencil</v-icon>
				</template>
				<span>edit sales</span>
			</v-tooltip>
			</v-btn>
		</template>
		<v-card v-if="!loading">
			<v-card-title class="pt-6">
				<span class="subtitle-2">Sales of the
					<span class="accentColor">{{ modName }}</span> 
				</span>
			</v-card-title>
			<v-card-text class="black--text">
				<v-container grid-list-md>
				<v-form ref="form">
					<v-row>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="sales plan"
								v-model.number="salesPlan"
								name="salesPlan"
								type="text"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="production plan"
								v-model.number="productionPlan"
								name="productionPlan"
								type="text"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="retail price"
								v-model.number="retailPrice"
								name="retailPrice"
								type="text"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="price"
								v-model.number="price"
								name="price"
								type="text"
								@change="onceMore()">
							</v-text-field>
						</v-col>
					</v-row>
				</v-form>
				</v-container>
				<v-row justify="center" class="error mx-2">{{error}}</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="#1A237E" text
					class="text-capitalize" 
					@click="closeDialog">
					Close
				</v-btn>
				<v-btn color="#1A237E" text
					class="text-capitalize"
					:disabled="loading || Boolean(error)"
					@click="changeModel"
					>Save</v-btn>
			</v-card-actions>
		</v-card>
		<div v-else class="text-center">
			<loader></loader>
		</div>
	</v-dialog>
</template>

<script>
	import Loader from '../../layouts/Loader.vue'

	export default {
		props: ['brand', 'model', 'gameId', 'round'],
		data () {
			return	{
				dialog: false,
				error: '',
				trademark: this.brand.trademark,
				modName: this.model.model,
				id: this.brand.id,
				salesPlan: this.model.salesPlan,
				productionPlan: this.model.productionPlan,
				retailPrice: this.model.retailPrice,
				price: this.model.price
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			}
		},
		methods: {
			onceMore () {
				this.error = ''
			},
			async changeModel () {
				
				if (this.salesPlan == this.model.salesPlan && 
					this.productionPlan == this.model.productionPlan &&
					this.retailPrice == this.model.retailPrice && 
					this.price == this.model.price) {

					this.error = 'Anyone sales\' parameter were changed' 
				}
				else {

					if (this.salesPlan !== this.model.salesPlan) {
						this.model.salesPlan = this.salesPlan
					}
					if (this.productionPlan !== this.model.productionPlan) {
						this.model.productionPlan = this.productionPlan
					}
					if (this.retailPrice !== this.model.retailPrice) {
						this.model.retailPrice = this.retailPrice
					}
					if (this.price !== this.model.price) {
						this.model.price = this.price
					}
					
					try {
						await this.$store.dispatch('changeModel', {
							gameId: this.gameId,
							round: this.round,
							brandId: this.brand.id,
							model: this.model
						})
						this.closeDialog ();				
					}
					catch (error) {
						await this.$store.dispatch('setError', error.message)
					}
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''	
			}
		}
	}
</script>
